export default __webpack_public_path__ + "static/media/Wawanesa_wordmark_blue.8987cb1e.svg";